<div class="transfer-search" (clickOutside)="hideResults()" (keyup.escape)="hideResults()">
  <div class="search">
    <div class="form-group">
      <input
        #searchinput
        type="text"
        class="search form-control"
        [(ngModel)]="search"
        [ngClass]="{ 'has-results': searchResultsAreVisible }"
        placeholder="Search by tool id or description"
        (keyup)="handleSearch($event)"
        (keyup.arrowup)="handleTraverseUp()"
        (keyup.arrowdown)="handleTraverseDown()"
        (keyup.enter)="handleSelect()"
        (click)="showResults()" />
      <button type="button">
        <i class="fal fa-search"></i>
      </button>
    </div>
    <div *ngIf="searchResultsAreVisible" class="results" (click)="focusSearchInput()">
      <table>
        <thead>
          <tr>
            <th>Tool ID</th>
            <th>Tool Name</th>
            <th>Assigned To</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let row of searchResults; let currentIndex = index"
            [ngClass]="{ 'is-active': currentIndex == activeIndex, 'is-disabled': row.selected }"
            (click)="handleSelect(currentIndex)">
            <td>{{ row.toolId }}</td>
            <td [style]="{ 'max-width': '110px' }" class="text-truncate">{{ row?.model?.name }}</td>
            <td>{{ getPrimaryAssignment(row) }}</td>
            <td>{{ getAssignmentType(row) }}</td>
          </tr>
          <tr *ngIf="searchPagination.currentPage < searchPagination.totalPages">
            <td colspan="100%">
              <a class="link" href="#" (click)="fetchNext(searchPagination.nextPage, $event)">Load More</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
